import { CourseServiceInterface } from 'domain/services';
import {
  CourseListUseCaseInterface,
  CourseCreateUseCaseInterface,
  CourseDeleteUseCaseInterface,
  CourseUpdateUseCaseInterface,
  CourseGetByIdUseCaseInterface,
  GetAllCoursesByPersonUseCaseInterface,
  GetAllCoursesByUserUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  courseList: CourseListUseCaseInterface;
  courseCreate: CourseCreateUseCaseInterface;
  courseUpdate: CourseUpdateUseCaseInterface;
  courseDelete: CourseDeleteUseCaseInterface;
  courseGetById: CourseGetByIdUseCaseInterface;
  getAllCoursesByPerson: GetAllCoursesByPersonUseCaseInterface;
  getAllCoursesByUser: GetAllCoursesByUserUseCaseInterface;
}

export class CourseService implements CourseServiceInterface {
  private readonly _courseList: CourseListUseCaseInterface;
  private readonly _courseCreate: CourseCreateUseCaseInterface;
  private readonly _courseUpdate: CourseUpdateUseCaseInterface;
  private readonly _courseDelete: CourseDeleteUseCaseInterface;
  private readonly _courseGetById: CourseGetByIdUseCaseInterface;
  private readonly _getAllCoursesByPerson: GetAllCoursesByPersonUseCaseInterface;
  private readonly _getAllCoursesByUser: GetAllCoursesByUserUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._courseList = usecases.courseList;
    this._courseCreate = usecases.courseCreate;
    this._courseUpdate = usecases.courseUpdate;
    this._courseDelete = usecases.courseDelete;
    this._courseGetById = usecases.courseGetById;
    this._getAllCoursesByPerson = usecases.getAllCoursesByPerson;
    this._getAllCoursesByUser = usecases.getAllCoursesByUser;
  }

  courseList(
    params?: CourseListUseCaseInterface.Params,
  ): Promise<CourseListUseCaseInterface.Result[]> {
    return this._courseList.execute(params);
  }

  courseCreate(
    params: CourseCreateUseCaseInterface.Params,
  ): Promise<CourseCreateUseCaseInterface.Result> {
    return this._courseCreate.execute(params);
  }

  courseUpdate(
    params: CourseUpdateUseCaseInterface.Params,
  ): Promise<CourseUpdateUseCaseInterface.Result> {
    return this._courseUpdate.execute(params);
  }

  courseGetById(
    params: CourseGetByIdUseCaseInterface.Params,
  ): Promise<CourseGetByIdUseCaseInterface.Result> {
    return this._courseGetById.execute(params);
  }

  courseDelete(
    params: CourseDeleteUseCaseInterface.Params,
  ): Promise<CourseDeleteUseCaseInterface.Result> {
    return this._courseDelete.execute(params);
  }

  getAllCoursesByPerson(
    params: GetAllCoursesByPersonUseCaseInterface.Params,
  ): Promise<GetAllCoursesByPersonUseCaseInterface.Result> {
    return this._getAllCoursesByPerson.execute(params);
  }

  getAllCoursesByUser(
    params: GetAllCoursesByUserUseCaseInterface.Params,
  ): Promise<GetAllCoursesByUserUseCaseInterface.Result> {
    return this._getAllCoursesByUser.execute(params);
  }
}
